export default "__VITE_PUBLIC_ASSET__b1ebb20c__"